import React from 'react';
import { titleize } from 'inflection';

import { IndexTitle } from 'buyside/components/presentation/IndexPage/IndexPage';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import MessagesIndexAreaQuery from 'buyside/components/container/MessagesIndex/MessagesIndexAreaQueryContainer';
import MessagesIndexArea from 'buyside/components/presentation/MessagesIndexPage/MessagesIndexArea';

const MessagesIndexAreaContainer = ({ mailbox }) => {
  return (
    <>
      <IndexTitle>{titleize(mailbox)}</IndexTitle>
      <ErrorBoundary pageName={`${mailbox} messages index`}>
        <MessagesIndexAreaQuery mailbox={mailbox}>
          {({ loading, data }) => {
            if (loading) {
              return <LoadingSpinner size="medium" />;
            }

            const { messages, hasNextPage, fetchNextPage } = data;

            return (
              <MessagesIndexArea
                messages={messages}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
              />
            );
          }}
        </MessagesIndexAreaQuery>
      </ErrorBoundary>
    </>
  );
};

export default MessagesIndexAreaContainer;
